import { Controller } from 'stimulus';

function fadeOutReview(review) {
  if (review) {
    review.style.opacity = 0;
  }
}

function fadeInReview(review) {
  if (review) {
    review.style.opacity = 1;
  }
}

class Reviews extends Controller {
  connect() {
    this.numberOfSlides = this.reviewTargets.length;
    this.currentSlide = 0;

    this.onHeightCalculate();

    this.loop = setInterval(() => {
      this.nextReview();
    }, this.calculateSlideSpeed());
  }

  disconnect() {
    clearInterval(this.loop);
  }

  calculateSlideSpeed() {
    const longestTextLength = this.reviewTextTargets.reduce((accumulator, text) => (
      text.textContent.length > accumulator ? text.textContent.length : accumulator
    ), 0);

    const baseDuration = 1500;

    const length = longestTextLength * 10;

    return baseDuration + (length > 7000 ? 7000 : length);
  }

  onHeightCalculate() {
    const tallestReviewHeight = this.getTallestReviewsHeight();
    this.wrapperTarget.style.height = `${tallestReviewHeight}px`;
  }

  getTallestReviewsHeight() {
    return this.reviewTargets.reduce((accumulator, review) => (
      review.offsetHeight > accumulator ? review.offsetHeight : accumulator
    ), 0);
  }

  nextReview() {
    this.currentSlide += 1;

    if (this.currentSlide >= this.numberOfSlides) {
      this.currentSlide = 0;
    }

    this.reviewTargets.forEach(fadeOutReview);

    if (
      typeof this.reviewTargets[this.currentSlide] === 'undefined'
      || !this.reviewTargets[this.currentSlide]
    ) {
      return;
    }

    setTimeout(() => {
      fadeInReview(this.reviewTargets[this.currentSlide]);
    }, 200);
  }
}

Reviews.targets = [
  'review',
  'reviewText',
  'wrapper',
];

export default Reviews;
